<template>
    <div class="fzg-home-mobile">
      <div class="fzg-slogan">
        <fzg-menu/>
        <img class="banner-bg" src="../../assets/img2/mobile/home/banner.jpg" alt="">
        <img class="banner-data" src="../../assets/img2/mobile/home/banner-data2.jpg" alt="">
      </div>

      <div class="section fzg-ecosystem">
        <img class="eco-data" src="../../assets/img2/mobile/home/shengtai.jpg" alt="">
      </div>

      <div class="section fzg-ecosystem">
        <img class="eco-data" src="../../assets/img2/mobile/home/bus-intro.jpg" alt="">
      </div>

      <div class="section fzg-customer-comments">
        <img class="comments-title" src="../../assets/img2/mobile/home/title-comments.png" alt="">

        <div class="logo-line">
          <div class="item-area comment_nav_bar_item_wrap">
            <div class="logo-item"
              v-for="item in comment_list"
              :class="{'logo-item-active': item.id === current_comment.id}"
              @click="changeCurrentComment(item)">
              <div class="logo-wrap">
                <img class="logo" :src="item.logo">
              </div>
              <div class="dot">●</div>
            </div>
          </div>
          <div class="line-area">
            <div class="line-area-center">
              <div class="left" @click="showNextComment(-1)">
                <img src="../../assets/img2/pc/main/arrow-right.png" alt="">
              </div>
              <div class="right" @click="showNextComment(1)">
                <img src="../../assets/img2/pc/main/arrow-right.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="comments-data">
          <div class="intro-line">
            <p v-if="false">欣旺达电子股份有限公司（简称“欣旺达”）创立于1997年，于2011年在深交所上市（股票代码：300207），并于2022年成功发行GDR登陆瑞交所，是全球锂离子电池领域领军品牌。</p>
            <p>{{current_comment.intro}}</p>
          </div>
          <div class="comment-line">
            <div class="left-logo">
              <img src="../../assets/img2/pc/main/bottom-comma.png" alt="">
            </div>
            <div class="comment-content">
              <p v-if="false" >本轮融资过程中，我们的投资人和财务顾问都表现出非常强的专业认知，以及对欣旺达EVB未来战略规划的深度理解和支持。中国动力电池事业发展任重道远，欣旺达一定不负众望，埋头苦干，坚持以成就客户、激情奋斗、团结合作为核心价值观，塑造具有全球影响力的品牌，为员工、股东以及整个中国锂电行业创造更大的价值。</p>
              <p> {{ current_comment.content }} </p>
            </div>
            <div class="right-logo">
              <img src="../../assets/img2/pc/main/bottom-comma.png" alt="">
            </div>
            <!-- @todo 添加落款 单独-->
            <div class="right-bottom"> ——{{current_comment.name}} </div>
          </div>
        </div>
      </div>

      <div class="fzg-activity">
        <img class="title-activity" src="../../assets/img2/mobile/home/fzg-title-activity.png" alt="">
        <div class="activity-area">
          <div class="act-item"
            v-for="(item,index) in activity_list">
            <a :href="item.link" target="_blank">
              <div class="act-icon">
                <img :src="item.banner" alt="">
              </div>
              <div class="right-content">
                <div class="act-title">{{ item.title.length > 35 ? item.title.substr(0,35) + '...' : item.title }}</div>
                <div v-if="false" class="act-content">{{ item.content.length > 40 ? item.content.substr(0,40) + '...': item.content }}</div>
              </div>
            </a>
          </div>

          <div class="bottom-activity-links">
            <a class="left-link" href="/news">凡卓交易</a> | <a class="right-link" href="/news#activity">近期活动</a>
          </div>

          <div class="act-item" v-if="false">
            <img class="act-icon" src="../../assets/img2/pc/fzg-bussiness-icon1.jpg" alt="">
            <div class="right-content">
              <div class="act-title">小饭桌创服</div>
              <div class="act-content">国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，拥有包含小饭桌ROADSHOW、小饭桌创业课程、小饭桌创服媒体、小饭局沙龙、产业专家库、社群等明星产品</div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>

import util from '../../assets/js/util'

import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu,
    },
    props:[''],
    data(){
        return{
          comment_list: [],
          current_comment: {},
          activity_list: [],
        }
    },
    methods:{

      getCommentList() {
        var self = this
        util.resource({
            url: '/api/fzg/home/customer_comments/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.comment_list = res.data.comments
                if (self.comment_list.length > 0) {
                  self.current_comment = self.comment_list[0]
                }
              }
            }
        })
      },
      changeCurrentComment(comment) {
        this.current_comment = comment
      },
      showNextComment (direction) {
        var ids = this.comment_list.map(item => item.id)
        var currentIndex = ids.indexOf(this.current_comment.id)
        if (direction > 0 && currentIndex < ids.length - 1) {
          currentIndex++
        } else if (direction < 0 && currentIndex >= 1) {
          currentIndex--
        }
        this.current_comment = this.comment_list[currentIndex]
      },

      getActivityList() {
        var self = this
        util.resource({
            url: '/api/fzg/home/news/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.activity_list = res.data.list
              }
            }
        })
      },
    },
    mounted(){
      this.getCommentList()
      this.getActivityList()
    },
    watch: {
      'current_comment': function(val) {
        if (val) {
          var ids = this.comment_list.map(item =>item.id)
          var currentIndex = ids.indexOf(this.current_comment.id)
          var scroll_size = 0;
          if (currentIndex > 2) {
              scroll_size = currentIndex - 2;
          } else {
              scroll_size = 0;
          }
          $('.comment_nav_bar_item_wrap').animate({scrollLeft: 100 * (scroll_size)});
        }
      }
    },

}
</script>

<style lang="scss">
.fzg-home-mobile{
  .fzg-slogan {
    // border: 1px solid red;
    // background: url(https://static-image.xfz.cn/1686266413907/home-bn.jpg) no-repeat;
    background-position: center;
    background: url(../../assets/img2/mobile/home/banner.jpg) no-repeat;
    background-size: 100% auto;
    position: relative;
    .banner-bg {
      width: 100%;
      height: auto;
    }
    .banner-data {
      width: 100%;
      height: auto;
    }
  }
  .fzg-ecosystem {
    // border: 1px solid green;
    overflow: auto;
    // height: 900px;
    margin: 0 auto;
    position: relative;
    .eco-data {
      width: 100%;
      height: auto;
    }
  }

  .fzg-customer-comments {
    // border: 1px solid green;
    // height: 800px;
    overflow: auto;
    clear: both;
    margin: 0 auto;
    position: relative;
    .comments-title {
      width: 100px;
      display: block;
      margin: 40px auto 0;
    }

    .logo-line {
      // border: 1px solid #ccc;
      margin: 40px auto 0;
      .item-area {
        // border: 1px solid gray;
        margin: 0 60px;
        height: 68px;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        .logo-item {
          // border: 1px solid #ce262f;
          // background: #cccccc33;
          margin-right: 2px;
          display: inline-block;
          width: 100px;
          height: 70px;
          position: relative;
          .logo {
            // border: 1px solid #ccc;
            width: 100px;
            height: 40px;
          }
          .dot {
            width: 100%;
            height: 20px;
            // background: #cccccc88;
            text-align: center  ;
            color: #b5b5b5;
            bottom: -1px;
            position: absolute;
            font-size: 11px;
          }
        }
        .logo-item-active {
          // border: 1px solid red;
          .dot {
            color: #d7ad78;
          }
        }
        &::-webkit-scrollbar {
          display: none;  /* Safari and Chrome */
        }
      }
      .line-area {
        width: 100%;
        border-bottom: 1px solid #d7ad78;
        margin-top: -10px;
        .line-area-center {
          width: 100%;
          margin: 0 auto;
          position: relative;
          .left {
            cursor: pointer;
            position: absolute;
            width: 30px;
            height: 30px;
            left: 30px;
            top: -15px;
            background: white;
            border: 1px solid #d7ad78;
            img {
              width: 10px;
              display: block;
              position: absolute;
              top: 4px;
              left: 7px;
              transform: rotate(180deg);
            }
          }
          .right {
            cursor: pointer;
            position: absolute;
            width: 30px;
            height: 30px;
            right: 30px;
            top: -15px;
            background: white;
            border: 1px solid #d7ad78;
            img {
              width: 10px;
              display: block;
              position: absolute;
              top: 4px;
              left: 7px;
            }
          }
        }
      }
    }

    .comments-data {
      // border: 1px solid #ce262f;
      // width: 1100px;
      margin: 50px auto 10px;
      color: #444444;
      .intro-line {
        // border: 1px solid #ce262f;
        // width: 1100px;
        margin: 0 auto;
        line-height: 1.6;
        padding: 20px 30px;
        text-align: justify;
        font-size: 13px;
      }
      .comment-line {
        // width: 1100px;
        margin: 0 auto;
        min-height: 200px;
        background: #f7f7f7;
        .left-logo {
          // border: 1px solid red;
          width: 40px;
          height: 60px;
          margin-left: 30px;
          margin-bottom: 10px;
          transform: rotate(180deg);
          img {
            width: 30px;
          }
        }
        .comment-content {
          // border: 1px solid red;
          text-align: justify;
          padding: 10px 30px 80px;
          font-size: 13px;
          line-height: 1.6;
        }
        .right-logo {
          position: absolute;
          // border: 1px solid red;
          width: 40px;
          height: 40px;
          right: 30px;
          bottom: 44px;
          img {
            width: 30px;
          }
        }
        .right-bottom {
          // border: 1px solid red;
          font-size: 13px;
          display: inline-block;
          position: absolute;
          bottom: 30px;
          right: 50px;
        }
      }

    }
  }

  .fzg-activity{
    // border: 1px solid green;
    padding-top: 30px;
    overflow: auto;
    clear: both;
    position: relative;
    height: 100%;
    .title-activity {
      display: block;
      // border: 1px solid gray;
      width: 90px;
      margin: 0 auto;
    }
    .activity-area {
      // border: 1px solid red;
      margin: 40px auto 40px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      .act-item {
        // border: 1px solid #ccc;
        background: #f7f7f7;
        margin-bottom: 15px;
        .act-icon {
          // border: 1px solid green;
          vertical-align: top;
          width: 140px;
          height: 95px;
          overflow: hidden;
          display: inline-block;
          text-align: center;
          position: relative;
          img {
            display: block;
            width: 140px;
            height: 95px;
            position: absolute;
            top:0;
            left: 0;
            right: 0;
            bottom: 0;
            object-fit: contain;
          }
        }
        .right-content {
          // border: 1px solid #ccc;
          text-align: left;
          vertical-align: top;
          width: 240px;
          height: 95px;
          display: inline-block;
          padding: 10px;
          overflow: hidden;
          max-height: 120px;
          .act-title {
            // border: 1px solid red;
            font-size: 16px;
            font-weight: bold;
            margin-top: 5px;
            &:hover {
              color: #d7ad78;
            }
          }
          .act-content {
            font-size: 14px;
            margin-top: 15px;
            color: #444444;
            line-height: 1.4;
          }
        }
      }
      .bottom-activity-links {
        clear: both;
        width: 100%;
        margin: 0 auto;
        // border: 1px solid red;
        padding: 15px;
        text-align: center;
        .left-link, .right-link {
          cursor: pointer;
          font-size: 17px;
          padding: 15px;
          &:hover {
            // color: #ce262f;
            color: #d7ad78;
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// FzgHomeMobile.vue?45d4ed7f